import React, { useState, useEffect } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";

const models = [
  { 
    name: "Furniture",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/5fda2003df16e4003ab24bd9.glb" :
      "/wp-content/themes/personal-architect/assets/glb/5fda2003df16e4003ab24bd9.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/5fda2003df16e4003ab24bd9.webp" :
      "/wp-content/themes/personal-architect/assets/webp/5fda2003df16e4003ab24bd9.webp",
  },
  { 
    name: "Windows",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/63cffbd681362100394ae2c4.glb" :
      "/wp-content/themes/personal-architect/assets/glb/63cffbd681362100394ae2c4.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/63cffbd681362100394ae2c4.webp" :
      "/wp-content/themes/personal-architect/assets/webp/63cffbd681362100394ae2c4.webp",
  },
  { 
    name: "Cabinets",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/64a32e31d13fbfc4f0ab1fb7.glb" :
      "/wp-content/themes/personal-architect/assets/glb/64a32e31d13fbfc4f0ab1fb7.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/64a32e31d13fbfc4f0ab1fb7.webp" :
      "/wp-content/themes/personal-architect/assets/webp/64a32e31d13fbfc4f0ab1fb7.webp",
  },
  { 
    name: "Lighting",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/606c70f02216ae003b0f5d46.glb" :
      "/wp-content/themes/personal-architect/assets/glb/606c70f02216ae003b0f5d46.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/606c70f02216ae003b0f5d46.webp" :
      "/wp-content/themes/personal-architect/assets/webp/606c70f02216ae003b0f5d46.webp",
  },
  { 
    name: "Plumbing",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/6585e852e3c38ddeded71bca.glb" :
      "/wp-content/themes/personal-architect/assets/glb/6585e852e3c38ddeded71bca.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/6585e852e3c38ddeded71bca.webp" :
      "/wp-content/themes/personal-architect/assets/webp/6585e852e3c38ddeded71bca.webp",
  },
  { 
    name: "Décor",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/605375728c8237003a8f98b8.glb" :
      "/wp-content/themes/personal-architect/assets/glb/605375728c8237003a8f98b8.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/605375728c8237003a8f98b8.webp" :
      "/wp-content/themes/personal-architect/assets/webp/605375728c8237003a8f98b8.webp",
  },
  { 
    name: "Electronics",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/5c4b60b660d28d5650657d31.glb" :
      "/wp-content/themes/personal-architect/assets/glb/5c4b60b660d28d5650657d31.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/5c4b60b660d28d5650657d31.webp" :
      "/wp-content/themes/personal-architect/assets/webp/5c4b60b660d28d5650657d31.webp",
  },
  { 
    name: "Equipment",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/6054a93c8c8237003a8f98e6.glb" :
      "/wp-content/themes/personal-architect/assets/glb/6054a93c8c8237003a8f98e6.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/6054a93c8c8237003a8f98e6.webp" :
      "/wp-content/themes/personal-architect/assets/webp/6054a93c8c8237003a8f98e6.webp",
  },
  { 
    name: "HVAC",
    src: process.env.NODE_ENV === 'development' ? 
      "/assets/glb/5dcae46598031322449971d5.glb" :
      "/wp-content/themes/personal-architect/assets/glb/5dcae46598031322449971d5.glb",
    image: process.env.NODE_ENV === 'development' ?
      "/assets/webp/5dcae46598031322449971d5.webp" :
      "/wp-content/themes/personal-architect/assets/webp/5dcae46598031322449971d5.webp",
  },
];

const ModelViewer = () => {
  const [selectedModel, setSelectedModel] = useState(models[0]);

  useEffect(() => {
    setSelectedModel(models[0]);
  }, []);

  const handleModelChange = (model) => {
    setSelectedModel(model);
  };

  return (
<Box id="models" sx={{ }}>
  {/* Container */}
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", lg: "row" }, // Column for small screens, row for large screens
      overflow: "hidden",
    }}
  >
    {/* Top Border */}
    <Box sx={{ backgroundColor: "#b71c1c", height: "4px" }} />

    {/* Left Column: Text + Image Grid */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        p: 5,
        gap: 2,
        minWidth: "300px",
        backgroundColor: "#f9f9f9",
      }}
    >
      {/* Text Area */}
      <Box>
        <Typography variant="h2" component="h2" fontSize={50} sx={{ fontWeight: 600, lineHeight: 0.9 }}>
          View Your Products in 3D
        </Typography>
        <Typography variant="h3" component="h3" fontSize={18} sx={{ my: 2 }}>
          Enable your customers to make inspired choices through an interactive design environment.
        </Typography>
        <Button variant="contained" href="#contact-us">Find Out How to Include Your Products</Button>
      </Box>

      {/* Image Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
          gap: 1,
        }}
      >
        {models.map((model, index) => (
          <Paper
            key={index}
            onClick={() => handleModelChange(model)}
            sx={{
              border: selectedModel.name === model.name ? "1px solid #b71c1c" : "1px solid #ccc",
              borderRadius: 1,
              overflow: "hidden",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: "white",
            }}
          >
            <Box
              component="img"
              src={model.image}
              alt={model.name}
              style={{
                width: "100%",
                height: "100px",
                objectFit: "contain",
              }}
            />
            <Typography
              sx={{
                backgroundColor: "white",
                fontSize: "0.7rem",
                textAlign: "center",
                padding: "4px",
              }}
            >
              {model.name}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>

    {/* Right Column: 3D Model Viewer */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "300px", lg: "50vh" }, // Ensure a minimum height for small screens
        minWidth: { xs: "100%", lg: "400px" },  // Adjust width based on screen size
        backgroundColor: "#f9f9f9",
        border: "10px solid #b71c1c",
      }}
    >
      {selectedModel && (
        <model-viewer
          ar
          ar-modes="webxr scene-viewer quick-look"
          camera-controls
          camera-orbit="0deg 270deg"
          disable-zoom
          style={{
            width: "100%",
            height: "100%",
            minHeight: "400px",
            maxHeight: "100%", // Limit height
            backgroundImage: process.env.NODE_ENV === 'development' ? 
              "url('/assets/svg/backgrounds/grid-vena.svg')" :
              "url('/wp-content/themes/personal-architect/assets/svg/backgrounds/grid-vena.svg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center center",
          }}
          tone-mapping="commerce"
          poster={selectedModel.image}
          shadow-intensity="1"
          src={selectedModel.src}
          touch-action="pan-y"
        />
      )}
    </Box>
  </Box>
</Box>

  );
};

export default ModelViewer;
